export default "__VITE_ASSET__CZTh5vzi__"